import React from 'react';
import { getRarityImage, getRarityColor } from '../utils/rarity';

interface RarityGemProps {
  rarity: string;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const RarityGem: React.FC<RarityGemProps> = ({ 
  rarity, 
  size = 24, 
  className = '', 
  style = {},
  title 
}) => {
  const rarityImage = getRarityImage(rarity);
  const rarityColor = getRarityColor(rarity);
  
  const gemStyle: React.CSSProperties = {
    width: size,
    height: size,
    display: 'inline-block',
    ...style
  };

  if (rarityImage) {
    return (
      <img
        src={rarityImage}
        alt={`${rarity} rarity`}
        className={`rarity-gem ${className}`}
        style={gemStyle}
        title={title || rarity}
      />
    );
  }

  // Fallback to colored circle
  return (
    <span
      className={`rarity-gem ${className}`}
      style={{
        ...gemStyle,
        background: rarityColor,
        borderRadius: '50%',
      }}
      title={title || rarity}
    />
  );
};

export default RarityGem; 